import { IoIosInformationCircleOutline } from 'react-icons/io';
import { MdDoneOutline } from 'react-icons/md';

export const RequiredField = () => {
  return <span className='required-icon'>*</span>;
};

export const InfoTooltip = ({ text, align = 'top', className, children }) => {
  return (
    <div className='info-icon-container'>
      <div className='tooltip-wrapper'>
        <IoIosInformationCircleOutline
          className={className ? `info-icon ${className}` : 'info-icon'}
          style={{ verticalAlign: align }}
        />
        <p className='tooltip-text'>
          <span className='tooltip-content'>{children ? children : text}</span>
        </p>
      </div>
    </div>
  );
};

export const CheckBox = ({ onChange, checked, className }) => {
  return (
    <div className={`round-checkbox-container ${className || ''}`}>
      <label className='round-checkbox'>
        <input
          type='checkbox'
          checked={checked}
          onChange={onChange || (() => {})}
        />
        <span className='custom-check'>
          {checked && <MdDoneOutline className='check-icon' />}
        </span>
      </label>
    </div>
  );
};
